export default "__VITE_ASSET__BdYE2JsC__"